import {CHAT_CONFIG} from "../services/ChatConfiguration";

export function agentsMetadataUrl(): string {
    return `${CHAT_CONFIG.API_URL}/agents-metadata`;
}

export function sessionsListUrl(databagId: number, limit: number, offset: number): string {
    return `${CHAT_CONFIG.API_URL}/sessions/list?databag_id=${databagId}&limit=${limit}&offset=${offset}`;
}

export function supersetGuestTokenUrl(dashboardUuid: string): string {
    return `${CHAT_CONFIG.API_URL}/superset/guest-token?dashboard_uuid=${encodeURIComponent(dashboardUuid)}`;
}
